import BaseOnboarding from 'onboarding/onboardings/baseonboarding';
import SidebarStructureStep from 'onboarding/onboardings/SidebarNavigation/steps/SidebarStructureStep';
import ImportantAccountsStep from 'onboarding/onboardings/SidebarNavigation/steps/ImportantAccountsStep';
import SidebarDashboardMenuStep from 'onboarding/onboardings/SidebarNavigation/steps/SidebarDashboardMenuStep';
import WATSectionStep from 'onboarding/onboardings/SidebarNavigation/steps/WATSectionStep';
import AccountsSearchStep from 'onboarding/onboardings/SidebarNavigation/steps/AccountsSearchStep';
import SidebarBottomSectionStep from 'onboarding/onboardings/SidebarNavigation/steps/SidebarBottomSectionStep';
import appEventBus from 'appEventBus';

class SidebarNavigationOnboarding extends BaseOnboarding {
  static get name () {
    return 'sidebar-navigation-onboarding';
  }

  static get trackingName () {
    return 'onboarding_navigation';
  }

  static async checkCondition () {
    return true;
  }

  steps () {
    return [
      {
        target: '#page-layout-sidebar #sidebar-accounts-section',
        attachToHighlight: true,
        header: 'Задайте удобную структуру',
        component: SidebarStructureStep,
        params: {
          placement: 'right',
          enableScrolling: true
        },
        events: {
          on () {
            window.ymReachGoal('ONBOARDING_NAVIGATION_START');
          }
        },
        width: '408px',
        highlightTarget: '#page-layout-sidebar #sidebar-accounts-section',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 4,
          maskSizeOffsetY: 8
        }
      },
      {
        target: '#page-layout-sidebar #header__important-accounts',
        attachToHighlight: true,
        header: 'Закрепляйте важные аккаунты',
        component: ImportantAccountsStep,
        params: {
          placement: 'right',
          enableScrolling: true
        },
        width: '408px',
        highlightTarget: '#page-layout-sidebar #header__important-accounts',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 4,
          maskSizeOffsetY: 8
        }
      },
      {
        target: '#page-layout-sidebar #header__dashboards',
        attachToHighlight: true,
        header: 'Настройте графики и диаграммы',
        component: SidebarDashboardMenuStep,
        params: {
          placement: 'right'
        },
        width: '408px',
        highlightTarget: '#page-layout-sidebar #header__dashboards',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 4,
          maskSizeOffsetY: 8
        }
      },
      {
        target: '#page-layout-sidebar .vat-create-block__vat',
        attachToHighlight: true,
        header: 'Выбирайте с НДС или без',
        component: WATSectionStep,
        params: {
          placement: 'right'
        },
        width: '408px',
        highlightTarget: '#page-layout-sidebar .vat-create-block__vat',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 10,
          maskSizeOffsetY: 10
        }
      },
      {
        target: '#page-layout-sidebar .sidebar__accounts-search',
        attachToHighlight: true,
        header: 'Легко находите нужное',
        component: AccountsSearchStep,
        params: {
          placement: 'right'
        },
        width: '408px',
        highlightTarget: '#page-layout-sidebar .sidebar__accounts-search',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 8,
          maskSizeOffsetY: 8
        }
      },
      {
        target: '#page-layout-sidebar .bottom-menu',
        attachToHighlight: true,
        header: 'Кнопки снизу',
        component: SidebarBottomSectionStep,
        params: {
          placement: 'top'
        },
        events: {
          off () {
            appEventBus.$emit('AUTORUN_ONBOARDING_COMPLETE');
            window.ymReachGoal('ONBOARDING_NAVIGATION_COMPLETE');
          }
        },
        width: '408px',
        highlightTarget: '#page-layout-sidebar .bottom-menu',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 10,
          maskSizeOffsetY: 10
        }
      }
    ];
  }
}

export default SidebarNavigationOnboarding;
